<template>
  <div class="page-main">
    <e-tabs v-if="isLoadTab" :list="statusList" :activeVal.sync="bill_status1" />
    <div class="flex flex-y-center flex-x-between m-b-10">
      <div class="flex flex-y-center">
        <el-button type="success" size="mini" icon="el-icon-plus" @click="itemDo()"
          >新增核算单
        </el-button>
        <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="searchListData">
          <span>销售日期:</span>
          <e-date-picker
            type="daterange"
            :value.sync="bill_date"
            isShowFast
            @change="searchListData"
          />
        </el-form>
        <!-- 类型切换：商品、原料、工艺、费用 -->
        <el-radio-group v-model="activeType" size="mini" class="m-l-10" @change="changeType">
          <el-radio-button label="商品" />
          <el-radio-button label="原料" />
          <el-radio-button label="工艺" />
          <el-radio-button label="费用" />
        </el-radio-group>
        <!-- 一键清空所有表头筛选 -->
        <el-button
          size="mini"
          icon="el-icon-refresh"
          class="m-l-10"
          :disabled="!hasFilter"
          @click="resetFilter"
          >重置筛选
        </el-button>
      </div>
    </div>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :show-footer="!!tableData.length"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 36 - 184"
      :footer-method="footerMethod"
      :cell-class-name="cellClassName"
      @cell-dblclick="itemDbDo"
      @resizable-change="handleColumnResize"
    >
      <!-- slot_header 表头筛选 -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          :value="filterData[column.field]"
          placeholder="输入关键字"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <!-- resultStart -->
      <template #default_bill_code="{ row }">
        <el-link type="primary" @click="itemDo(row.bill_id)">
          {{ row.bill_code }}
        </el-link>
      </template>
      <template #default_zhi_zao_ming_xi="{ row }">
        <el-link type="primary" @click="itemMadeDetail(row.bill_id)">
          <div class="flex flex-y-center">
            <span class="iconfont icon-dingdan f-s-12"></span>
            <span class="m-l-2">制造明细</span>
          </div>
        </el-link>
      </template>
      <template #default_zhi_zao_liu_cheng="{ row }">
        <el-link type="primary" @click="itemMadeView(row.bill_id)">
          <div class="flex flex-y-center">
            <span class="iconfont icon-ziliucheng f-s-12"></span>
            <span class="m-l-2">制造流程</span>
          </div>
        </el-link>
      </template>
      <template #default_jiao_huo_ri_qi="{ row }">
        <div>{{ row.jiao_huo_ri_qi || '-' }}</div>
        <div class="c-orange">{{ row.jiao_huo_ri_qi_str }}</div>
      </template>
      <template #default_company_name="{ row }">
        <el-link type="primary" @click="customerFollowUpDetail(row.company_id)">{{
          row.company_name
        }}</el-link>
      </template>
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image v-if="row.list_chan_pin_tu" :list.sync="row.list_chan_pin_tu" disabled />
      </template>

      <!-- resultOrderYes -->
      <template #default_profit_rate="{ row }">{{ row.profit_rate }}%</template>

      <!-- resultOrderNo -->
      <template #default_list_gong_cheng_tu="{ row }">
        <e-upload-image
          v-if="row.list_gong_cheng_tu"
          :list.sync="row.list_gong_cheng_tu"
          disabled
        />
      </template>
      <template #default_list_yuan_wen_jian="{ row }">
        <e-upload-file v-if="row.list_yuan_wen_jian" :list.sync="row.list_yuan_wen_jian" disabled />
      </template>
      <template #default_list_jian_ce_mu_ban="{ row }">
        <e-upload-file
          v-if="row.list_jian_ce_mu_ban"
          :list.sync="row.list_jian_ce_mu_ban"
          disabled
        />
      </template>
      <template #default_list_jian_ce_bao_gao="{ row }">
        <e-upload-file
          v-if="row.list_jian_ce_bao_gao"
          :list.sync="row.list_jian_ce_bao_gao"
          disabled
        />
      </template>
      <template #default_jin_du="{ row }">
        <div class="flex flex-center">
          <div
            class="flex flex-y-center"
            v-for="(item, index) in diffSearchTypeShowData.list"
            :key="index"
          >
            <span v-if="index">-</span>
            <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
            <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
            <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
          </div>
        </div>
      </template>

      <!-- resultEnd -->
      <template #default_operate="{ row }">
        <el-dropdown>
          <el-button type="default" size="mini">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="row.isYinYong" @click.native="itemCopy(row.bill_id)">
              <span class="c-green">引用新增</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="itemPrintQuote(row.bill_id)">
              打印报价单
            </el-dropdown-item>
            <el-dropdown-item @click.native="itemPrintVerify(row.bill_id)">
              打印核算单
            </el-dropdown-item>
            <el-dropdown-item @click.native="itemPrintOrder(row.bill_id)">
              打印样板生产单
            </el-dropdown-item>
            <el-dropdown-item @click.native="itemPrintLiucheng(row)">
              打印制造流程
            </el-dropdown-item>
            <el-dropdown-item @click.native="itemAudit(row.bill_id)">
              <span class="c-blue">提交审核</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="itemContract(row.bill_id)">
              <span class="c-blue">生成合同</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="itemDelete(row)">
              <span class="c-red">删除</span>
            </el-dropdown-item>
            <!-- <el-dropdown-item @click.native="itemPrintContract(row.bill_id)">
              打印合同
            </el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-新增核算单 -->
    <PopupVerifyDo
      v-if="isShowPopupVerifyDo"
      :show.sync="isShowPopupVerifyDo"
      :isSourceHeTong="isSourceHeTong"
      :billId="activeBillId"
      @success="updatePage"
    />

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="activeBillId"
    />

    <!-- 弹窗-制造流程 -->
    <b-popup-verify-goods-view
      v-if="isShowPopupVerifyGoodsView"
      :show.sync="isShowPopupVerifyGoodsView"
      :id="activeBillId"
    />

    <!-- 弹窗-跟进记录 -->
    <b-popup-customer-follow-up-detail
      v-if="isShowPopupCustomerFollowUpDetail"
      :show.sync="isShowPopupCustomerFollowUpDetail"
      :id="activeId"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_verify_page_list',
  components: {
    PopupVerifyDo: () => import('../common/popup-verify-do')
  },
  data() {
    return {
      // loading
      loading: true,
      isLoadTab: false,

      // filter
      activeType: '商品',
      bill_date: [],
      filterData: {
        bill_code: '',
        ding_dan_lei_xing: '',
        saler_name: '',
        company_name: '',
        company_id: '',
        jiao_huo_ri_qi: '',
        name: '',
        spec: '',
        unit: '',
        counts: '',
        goods_price: '',
        goods_amount: '',
        sales_price: '',
        sales_amount: '',
        profit_row_unit: '',
        profit_row: '',
        profit_rate: '',
        remark: '',
        xiang_mu_ming_cheng: '',
        bill_remark: '',
        gong_cheng_fu_ze_ren_name: '',
        pmc_fu_ze_ren_name: '',
        saler_company_name: ''
      },
      sortData: {
        bill_date: 'desc'
      },
      bill_status1: '全部',

      // table
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        zan_cun_count: '',
        yi_bo_hui_count: ''
      },

      // popup
      isShowPopupVerifyDo: false,
      isSourceHeTong: false,
      isShowPopupVerifyGoodsDetail: false,
      isShowPopupVerifyGoodsView: false,
      activeBillId: null,
      activeId: null,
      isShowPopupCustomerFollowUpDetail: false
    }
  },
  computed: {
    // 是否存在已生效的表头筛选条件
    hasFilter() {
      let result = Object.keys(this.filterData).some((key) => {
        let val = this.filterData[key]
        return val !== '' && val !== null && val !== undefined
      })
      return result
    },
    // 表头联想筛选接口，随类型切换
    headerFilterUrl() {
      let map = {
        商品: '/admin/gcvip/checkBill2/list3ShangPinSearchHeard',
        原料: '/admin/gcvip/checkBill2/list3YuanLiaoSearchHeard',
        工艺: '/admin/gcvip/checkBill2/list3JiaGongSearchHeard',
        费用: '/admin/gcvip/checkBill2/list3QiTaFeiYongSearchHeard'
      }
      return map[this.activeType]
    },
    // 是否是管理员
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    // 当前登录账号id
    accountId() {
      return this.$store.state.loginAccount.id
    },
    // 状态列表
    statusList() {
      let result = [
        {
          key: '全部',
          val: '全部',
          type: 'info'
        },
        {
          key: '暂存',
          val: '暂存',
          count: this.totalObj.zan_cun_count,
          type: 'info',
          isRed: true
        },
        {
          key: '已驳回',
          val: '已驳回',
          count: this.totalObj.yi_bo_hui_count,
          type: 'danger'
        }
      ]
      return result
    },
    // 不同类型的显示名称和进度阶段
    diffSearchTypeShowData() {
      let map = {
        商品: {
          type: '商品',
          list: ['待执行', '执行中', '已完成']
        },
        原料: {
          type: '原料',
          list: ['待采购', '采购中', '已入库']
        },
        工艺: {
          type: '工艺',
          list: ['待加工', '加工中', '已完成']
        },
        费用: {
          type: '费用',
          list: ['待执行', '执行中', '已完成']
        }
      }
      return map[this.activeType]
    },
    // 表格列
    tableColumn() {
      let resultStart = [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '销售单号',
          field: 'bill_code',
          slots: { header: 'header_input', default: 'default_bill_code' }
        },
        {
          title: '制造明细',
          field: 'zhi_zao_ming_xi',
          slots: { default: 'default_zhi_zao_ming_xi' }
        },
        {
          title: '制造流程',
          field: 'zhi_zao_liu_cheng',
          slots: { default: 'default_zhi_zao_liu_cheng' }
        },
        {
          title: '订单类型',
          field: 'ding_dan_lei_xing',
          slots: { header: 'header_input' }
        },
        {
          title: '销售日期',
          field: 'bill_date'
        },
        {
          title: '业务员',
          field: 'saler_name',
          slots: { header: 'header_input' }
        },
        {
          title: '工程负责人',
          field: 'gong_cheng_fu_ze_ren_name',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: 'PMC负责人',
          field: 'pmc_fu_ze_ren_name',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: '客户名称',
          field: 'company_name',
          width: 180,
          slots: { header: 'header_input', default: 'default_company_name' }
        },
        {
          title: '客户编号',
          field: 'company_id',
          width: 80,
          slots: { header: 'header_input' }
        },
        {
          title: '交货日期',
          field: 'jiao_huo_ri_qi',
          slots: { header: 'header_input', default: 'default_jiao_huo_ri_qi' }
        },
        {
          title: `${this.diffSearchTypeShowData.type}图片`,
          field: 'list_chan_pin_tu',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: `${this.diffSearchTypeShowData.type}名称`,
          field: 'name',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '单位',
          field: 'unit',
          width: 60,
          slots: { header: 'header_input' }
        },
        {
          title: '数量',
          field: 'counts',
          slots: { header: 'header_input' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          slots: { header: 'header_input' }
        },
        {
          title: '金额(元)',
          field: 'goods_amount',
          slots: { header: 'header_input' }
        }
      ]
      let resultOrderYes = [
        {
          title: '销售单价(元)',
          field: 'sales_price',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '销售金额(元)',
          field: 'sales_amount',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '每件利润(元)',
          field: 'profit_row_unit',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '合计利润(元)',
          field: 'profit_row',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '利润率',
          field: 'profit_rate',
          slots: { header: 'header_input', default: 'default_profit_rate' }
        }
      ]
      let resultOrderNo = [
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' }
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' }
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' }
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        }
      ]
      let resultCenter = this.activeType === '商品' ? resultOrderYes : resultOrderNo
      let resultEnd = [
        {
          title: '备注',
          field: 'remark',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '项目名称',
          field: 'xiang_mu_ming_cheng',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '单据备注',
          field: 'bill_remark',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '开单公司',
          field: 'saler_company_name',
          width: 180,
          slots: { header: 'header_input' }
        },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      let result = [...resultStart, ...resultCenter, ...resultEnd]
      this.$util.initTableColumnWidth(this.$options.tableName, result)
      return result
    }
  },
  watch: {
    // 监听状态变化
    bill_status1() {
      this.searchListData()
    }
  },
  mounted() {
    // 标记状态 tab 是否因路由参数改变（改变时 watch 会自动触发首查，避免重复请求）
    let isQueryByWatch = false
    this.isLoadTab = false
    if (this.$route.query.status && this.$route.query.status !== this.bill_status1) {
      this.bill_status1 = this.$route.query.status
      isQueryByWatch = true
    }
    this.isLoadTab = true
    if (!isQueryByWatch) this.getListData()
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 表头筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 类型切换，清空表头筛选后重新搜索
    changeType() {
      this.resetFilterData()
      this.searchListData()
    },
    // 重置表头筛选并刷新列表
    resetFilter() {
      this.resetFilterData()
      this.searchListData()
    },
    // 重置表头筛选
    resetFilterData() {
      Object.keys(this.filterData).forEach((key) => {
        this.filterData[key] = ''
      })
    },
    // 更新页面
    updatePage() {
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let urlMap = {
        商品: '/admin/gcvip/checkBill2/list3ShangPin',
        原料: '/admin/gcvip/checkBill2/list3YuanLiao',
        工艺: '/admin/gcvip/checkBill2/list3JiaGong',
        费用: '/admin/gcvip/checkBill2/list3QiTaFeiYong'
      }
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        bill_status1: this.bill_status1 === '全部' ? '核算单' : this.bill_status1,
        bill_date: this.bill_date || [],
        filterData: this.filterData,
        sortData: this.$util.deepCopy(this.sortData)
      }

      this.$api({
        method: 'post',
        url: urlMap[this.activeType],
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            list.forEach((item) => {
              item.isYinYong = this.isAdmin || item.saler_id === this.accountId
            })
            this.tableData = list
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.zan_cun_count = res.data.zan_cun_count
            this.totalObj.yi_bo_hui_count = res.data.yi_bo_hui_count
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          let counts = this.$tool.listAddTotal(data, 'counts')
          let goods_amount = this.$tool.listAddTotal(data, 'goods_amount')
          let sales_amount = this.$tool.listAddTotal(data, 'sales_amount')
          let profit_row_unit = this.$tool.listAddTotal(data, 'profit_row_unit')
          let profit_row = this.$tool.listAddTotal(data, 'profit_row')
          let profit_rate = this.$tool.listAddTotal(data, 'profit_rate') / data.length
          let profit_rate_avg = this.$util.getPoint(profit_rate, 'down', 2)
          if (columnIndex === 0) return '合计'
          if (column.field === 'counts') return counts
          if (column.field === 'goods_amount') return goods_amount
          if (column.field === 'sales_amount') return sales_amount
          if (column.field === 'profit_row_unit') return profit_row_unit
          if (column.field === 'profit_row') return profit_row
          if (column.field === 'profit_rate') return `${profit_rate_avg}%`
        })
      ]
    },
    // 行类名计算，实现按字段分组的斑马纹效果
    cellClassName(rowData) {
      let result = this.$tool.getTableCellClassName(this.tableData, rowData, 'bill_id')
      return result
    },

    // 项-制造明细
    itemMadeDetail(bill_id) {
      this.activeBillId = bill_id
      this.isShowPopupVerifyGoodsDetail = true
    },
    // 项-制造流程
    itemMadeView(bill_id) {
      this.activeBillId = bill_id
      this.isShowPopupVerifyGoodsView = true
    },
    // 项-增改
    itemDo(bill_id = null) {
      this.isSourceHeTong = false
      this.activeBillId = bill_id
      this.isShowPopupVerifyDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.bill_id)
    },
    // 项-引用新增
    itemCopy(bill_id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/copy',
        params: {
          id: bill_id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('引用新增成功')
            this.getListData()
          }
        })
        .catch(() => {})
    },
    // 项-打印报价单
    itemPrintQuote(bill_id) {
      window.open(`/new/verify/print/quote?id=${bill_id}`, '_blank')
    },
    // 项-打印核算单
    itemPrintVerify(bill_id) {
      window.open(`/new/verify/print/verify?id=${bill_id}`, '_blank')
    },
    // 项-打印样板生产单
    itemPrintOrder(bill_id) {
      window.open(`/new/verify/print/order?id=${bill_id}&isDemo=true`, '_blank')
    },
    // 项-打印制造流程
    itemPrintLiucheng(row) {
      let url = `/new/verify/print/liucheng?billId=${row.bill_id}&goodsId=${row.id}`
      window.open(url, '_blank')
    },
    // 项-提交审核
    itemAudit(bill_id) {
      this.$confirm('提交审核后，需前往订单列表进行管理！', '提示', {
        confirmButtonText: '确认提交',
        cancelButtonText: '放弃'
      })
        .then(() => {
          this.itemAuditConfirm(bill_id)
        })
        .catch(() => {})
    },
    // 项-提交审核-确认
    itemAuditConfirm(bill_id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/salerDoAudit',
        params: {
          id: bill_id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已提交审核')
          this.getListData()
        }
      })
    },
    // 项-生成合同
    itemContract(bill_id) {
      this.isSourceHeTong = true
      this.activeBillId = bill_id
      this.isShowPopupVerifyDo = true
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm(`销售单号：${row.bill_code}，是否删除该核算单?`, '提示')
        .then(() => {
          this.itemDeleteConfirm(row.bill_id)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    itemDeleteConfirm(bill_id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/doDelete',
        params: {
          id: bill_id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success(res.data.msg)
            this.getListData()
          }
        })
        .catch(() => {})
    },
    // 客户跟进-详情
    customerFollowUpDetail(id) {
      this.activeId = id
      this.isShowPopupCustomerFollowUpDetail = true
    }
    // // 项-打印合同
    // itemPrintContract(bill_id) {
    //   window.open(`/new/verify/print/contract?id=${bill_id}`, '_blank')
    // }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
